import { AnalyticsSource, IEnvironment, UniqueId } from '@communication-center/data-objects';
import { commonActions } from '../actionTypes';
import { ThunkAction } from '../../infrastructure/store.interface';
import { FeatureFlags } from '../../components/Dialogs/FeatureFlagDialog/FeatureFlagDialog';
import { logAuthorizationPerformance } from '../../services/performence.service';
import { authorization } from '../../helpers/authorization/authorization';
import logger from '../../services/logger.service';
import { WalkmeSdkService } from '../../infrastructure/WalkmeSdkProvider/types';

export enum NotificationPauseState {
    Pause,
    Resume
}

export const authorize = (walkmeSdkService: WalkmeSdkService): ThunkAction => async dispatch => {
    try {
        const res = await authorization(walkmeSdkService);
        let data;
        if (typeof res === 'object') {
            data = res.data;

            logAuthorizationPerformance();

            dispatch({
                type: commonActions.AUTHORIZE,
                payload: data
            });
        }
    } catch (e: $TSFixMe) {
        logger.error(`error in authorization process: ${e.message}`, e, { name: 'authorization' });
        throw e;
    }
};

export const handleWalkmeSystemChange = (payload: {
    currentSystem: UniqueId;
    currentNumericSystemId: number;
    environments: IEnvironment[];
    currentEnvironment: IEnvironment;
}): ThunkAction => (dispatch, getState) => {
    const { currentSystem } = getState().common;

    if (currentSystem !== payload.currentSystem) {
        dispatch({
            type: commonActions.SYSTEM_CHANGED,
            payload
        });
    }
};

export const handleWalkmeEnvironmentChange = (environment: IEnvironment): ThunkAction => (dispatch, getState) => {
    const { id } = getState().common.currentEnvironment;
    if (id !== environment.id) {
        dispatch({
            type: commonActions.ENVIRONMENT_CHANGED,
            payload: environment
        });
    }
};

export const setFeatureFlags = (featureFlags: FeatureFlags) => ({
    type: commonActions.SET_LOCAL_FEATURE_FLAGS,
    payload: featureFlags
});

export const setForceAnalyticsSource = (forceSource: AnalyticsSource | undefined) => ({
    type: commonActions.SET_FORCE_ANALYTICS_SOURCE,
    payload: forceSource
});
